export const MERGE_TAGS = [
  { key: 'student_name', label: 'Student Name' },
  { key: 'student_ref', label: 'Student Ref' },
  { key: 'student_email', label: 'Student Email' },
  { key: 'agency_name', label: 'Agency Name' },
  { key: 'company_name', label: 'Company Name' },
  { key: 'company_email', label: 'Company Email' },
  { key: 'owner_name', label: 'Owner Name' },
  { key: 'course', label: 'Course' },
  { key: 'intake', label: 'Intake' },
  { key: 'campus', label: 'Campus' },
  { key: 'today_date', label: 'Today Date' }
];

export const emptyMailAutoJobForm = {
  name: '',
  content_source: 'template',
  template_id: '',
  custom_subject: '',
  custom_body_html: '',
  mailbox_id: '',
  send_time: '09:00',
  send_timezone: 'Europe/Paris',
  recipient_students: true,
  recipient_companies: false,
  recipient_b2b_agencies: false,
  delay_days_students: 0,
  delay_days_companies: 0,
  delay_days_b2b_agencies: 0,
  is_active: true
};

export function jobToForm(job) {
  if (!job) return { ...emptyMailAutoJobForm };
  return {
    name: job.name || '',
    content_source: job.content_source === 'custom' ? 'custom' : 'template',
    template_id: job.template_id ? String(job.template_id) : '',
    custom_subject: job.custom_subject || '',
    custom_body_html: job.custom_body_html || '',
    mailbox_id: String(job.mailbox_id || ''),
    send_time: job.send_time || '09:00',
    send_timezone: job.send_timezone || 'Europe/Paris',
    recipient_students: !!job.recipient_students,
    recipient_companies: !!job.recipient_companies,
    recipient_b2b_agencies: !!job.recipient_b2b_agencies,
    delay_days_students: job.delay_days_students ?? 0,
    delay_days_companies: job.delay_days_companies ?? 0,
    delay_days_b2b_agencies: job.delay_days_b2b_agencies ?? 0,
    is_active: job.is_active !== false
  };
}

export function buildMailAutoJobPayload(form) {
  return {
    name: form.name.trim(),
    content_source: form.content_source,
    template_id: form.content_source === 'template' ? Number(form.template_id) : null,
    custom_subject: form.content_source === 'custom' ? form.custom_subject : null,
    custom_body_html: form.content_source === 'custom' ? form.custom_body_html : null,
    mailbox_id: Number(form.mailbox_id),
    send_time: form.send_time,
    send_timezone: form.send_timezone,
    recipient_students: !!form.recipient_students,
    recipient_companies: !!form.recipient_companies,
    recipient_b2b_agencies: !!form.recipient_b2b_agencies,
    delay_days_students: form.recipient_students ? Number(form.delay_days_students) : 0,
    delay_days_companies: form.recipient_companies ? Number(form.delay_days_companies) : 0,
    delay_days_b2b_agencies: form.recipient_b2b_agencies ? Number(form.delay_days_b2b_agencies) : 0,
    is_active: !!form.is_active
  };
}
